module.exports = __webpack_public_path__ + "media/images/new-favicon-16x16-1c55fd6933a71b7d4fddcc5f851989f8.ico";